// src/utils/templateUtils.js

// Simple function to get palette colors from user data
export const getPaletteColors = (userData) => {
  const colors = userData?.profile?.palette?.colors || [];
  if (colors.length === 0) {
    return ['#000000', '#333333', '#555555', '#777777', '#ffffff', '#000000'];
  }
  return colors;
};

// These are no longer needed but kept as empty functions to avoid errors
export const getTemplateStylesModule = () => ({});
export const getTemplateClass = () => '';
export const getSpecialTemplateStyles = () => ({});
export const getBannerStyles = () => ({});
export const getButtonStyles = () => ({});
export const getAvatarStyles = () => ({});
export const getIconStyles = () => ({});